import { Component } from '@angular/core';

@Component({
  selector: 'app-termini-condizioni',
  imports: [],
  templateUrl: './termini-condizioni.html',
  styleUrl: './termini-condizioni.css'
})
export class TerminiCondizioni {

}
